<template>
  <div>
    <v-btn
      v-if="showInstallButton"
      @click="installPwa"
      v-bind="$attrs"
      id="install-app"
      class="text-none"
      color="primary"
      depressed
      dark
    >
      Instalar App
    </v-btn>
  </div>
</template>

<script>
export default {
  data: () => ({
    deferredPrompt: null,
    showInstallButton: false,
  }),
  created() {
    window.addEventListener("beforeinstallprompt", this.beforeInstallPrompt);
  },
  beforeDestroy() {
    window.removeEventListener("beforeinstallprompt", this.beforeInstallPrompt);
  },
  methods: {
    beforeInstallPrompt(event) {
      this.deferredPrompt = event;
      this.showInstallButton = true;
    },
    installPwa() {
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt();

        this.deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === "accepted") {
            console.log("Usuário aceitou instalar o PWA");
          } else {
            console.log("Usuário recusou instalar o PWA");
          }
          this.deferredPrompt = null;
          this.showInstallButton = false;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#install-app {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
